// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");

function TMPUIKIT____Page$Subtitle(props) {
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("h4", {
              children: props.children,
              className: TailwindMerge.twMerge([
                    "pb-[11px] border-b border-gray-200 mb-[25px] font-medium text-[22px] leading-tight text-gray-800",
                    className
                  ])
            });
}

var Subtitle = {
  make: TMPUIKIT____Page$Subtitle
};

exports.Subtitle = Subtitle;
/* tailwind-merge Not a pure module */
